import React from 'react';
import { AppFooter } from '@readsavor/ui';
import { RouteNames, getRoutePath } from '../../routes/index.js';
import { TransitionLink } from '../../routes/TransitionLink.js';

const Footer: React.FC = () => {
  return (
    <AppFooter
      slotLeft={
        <TransitionLink
          to={getRoutePath(RouteNames.HOME)}
          className="text-interactive-emerald-flash text-[28px] font-bold"
        >
          ReadSavor
        </TransitionLink>
      }
      slotRight={
        <nav className="flex items-center space-x-6 text-base font-medium">
          <a
            href="https://www.producthunt.com/products/readsavor?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-readsavor"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="ReadSavor - Enjoy multilingual reading | Product Hunt"
              width="250"
              height="54"
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1052418&theme=light&t=1766217562006"
            />
          </a>
          <span className="text-interactive-emerald-flash">support@readsavor.com</span>
          <a href="/help" className="text-interactive-emerald-flash hover:text-[#FB923C]">
            Help
          </a>
          <a href="/blog" className="text-interactive-emerald-flash hover:text-[#FB923C]">
            Blog
          </a>
          <TransitionLink
            to={getRoutePath(RouteNames.TERMS_OF_SERVICE)}
            className="text-interactive-emerald-flash hover:text-[#FB923C]"
          >
            Terms of Use
          </TransitionLink>
          <TransitionLink
            to={getRoutePath(RouteNames.PRIVACY_POLICY)}
            className="text-interactive-emerald-flash hover:text-[#FB923C]"
          >
            Privacy Policy
          </TransitionLink>
        </nav>
      }
      slotBottom={
        <div className="text-sm text-interactive-emerald-flash">
          <span>© {new Date().getFullYear()} ReadSavor</span>
        </div>
      }
    />
  );
};

export default Footer;
